import React, { FC } from "react";
import { Icon } from "@evergis/ui";

import { LayerItem } from "./LayerItem";
import { DnDAnchor, ListItem } from "../styled";
import { useLayerItem } from "../hooks/useLayerItem";
import { useOutOfScale } from "../hooks/useOutOfScale";
import { usePresentationMode } from "../../../hooks/layout/usePresentationMode";
import { useIsShared } from "../../../hooks/api/useIsShared";
import { DraggableLayerItemProps } from "../types";

export const DraggableLayerItem: FC<DraggableLayerItemProps> = ({
  layer,
  provided,
  snapshot,
  isSelectable,
  isSelected,
  isExpanding,
  noMenu,
  noControl,
  noLegend,
  noIcon,
  noDrag,
  noVisibilityClick,
  toggleSelected,
}) => {
  const { isDragging } = snapshot;
  const isShared = useIsShared();
  const { isPresentationMode } = usePresentationMode();
  const layerItemInfo = useLayerItem(layer.name);
  const isOutOfScale = useOutOfScale(layerItemInfo.layer);
  const isTemp = layer?.name?.startsWith("temp");

  // Temporary disable drag for temp layers
  const dragHandleProps = isTemp || isPresentationMode || noDrag ? void 0 : provided.dragHandleProps;

  return (
    <ListItem
      ref={provided.innerRef}
      {...provided.draggableProps}
      {...dragHandleProps}
      zIndex={isExpanding ? 0 : 1}
      shared={isShared}
      disableShadow={isOutOfScale}
      isDragging={isDragging}
      noVisibilityClick={noVisibilityClick}
    >
      {!isShared && !isPresentationMode && !noControl && !noDrag && (
        <DnDAnchor visible={isDragging}>
          <Icon kind={"dragdrop"} />
        </DnDAnchor>
      )}
      <div {...provided.dragHandleProps} style={{ visibility: "hidden" }} />
      <LayerItem
        layer={layer}
        layerItemInfo={layerItemInfo}
        isSelectable={isSelectable}
        isSelected={isSelected}
        isOutOfScale={isOutOfScale}
        isDragging={isDragging}
        isExpanding={isExpanding}
        noMenu={noMenu}
        noControl={noControl}
        noLegend={noLegend}
        noIcon={noIcon}
        noVisibilityClick={noVisibilityClick}
        toggleSelected={toggleSelected}
      />
    </ListItem>
  );
};
